export const OPENING_CONFIG = {
  alwaysOpen: "always_open",
  shutdown: "shutdown",
  selectedHours: "selected_hours",
};
